export default "__VITE_ASSET__DbTyb9mf__"